import { httpClient } from "@/shared/lib/httpClient";
import {
    Project,
    ProjectCreateRequest,
    ProjectListResponse,
    ProjectUpdateRequest,
    AddMemberRequest,
    AddMemberResponse,
    SessionMember,
    Agent
} from "@/shared/types/session";

// Agentes (geralmente usados na criação de projetos)
export async function getAgents(): Promise<Agent[]> {
    return httpClient.get<Agent[]>('/agents');
}

// Projetos
export async function createProject(data: ProjectCreateRequest): Promise<Project> {
    return httpClient.post<Project>('/projects', data);
}

export async function getUserProjects(): Promise<ProjectListResponse> {
    return httpClient.get<ProjectListResponse>('/projects');
}

export async function getProject(projectId: string): Promise<Project> {
    return httpClient.get<Project>(`/projects/${projectId}`);
}

export async function updateProject(projectId: string, data: ProjectUpdateRequest): Promise<Project> {
    return httpClient.put<Project>(`/projects/${projectId}`, data);
}

export async function deleteProject(projectId: string): Promise<{ success: boolean; message: string }> {
    return httpClient.delete<{ success: boolean; message: string }>(`/projects/${projectId}`);
}

// Membros do Projeto
export async function getProjectMembers(projectId: string): Promise<SessionMember[]> {
    const response = await httpClient.get<SessionMember[] | { members?: SessionMember[] }>(`/projects/${projectId}/members`);
    if (Array.isArray(response)) return response;
    return response.members || [];
}

export async function addProjectMember(projectId: string, memberData: AddMemberRequest): Promise<AddMemberResponse> {
    return httpClient.post<AddMemberResponse>(`/projects/${projectId}/members`, memberData);
}

export async function removeProjectMember(projectId: string, memberId: number): Promise<{ success: boolean; message: string }> {
    return httpClient.delete<{ success: boolean; message: string }>(`/projects/${projectId}/members/${memberId}`);
}

export async function updateMemberRole(projectId: string, memberId: number, role: 'owner' | 'member'): Promise<{ success: boolean; message: string }> {
    return httpClient.patch<{ success: boolean; message: string }>(`/projects/${projectId}/members/${memberId}`, { role });
}

export async function leaveProject(projectId: string): Promise<{ success: boolean; message: string }> {
    return httpClient.post<{ success: boolean; message: string }>(`/projects/${projectId}/leave`);
}

const ProjectService = {
    getAgents,
    createProject,
    getUserProjects,
    getProject,
    updateProject,
    deleteProject,
    getProjectMembers,
    addProjectMember,
    removeProjectMember,
    updateMemberRole,
    leaveProject
};

export default ProjectService;
